package it.neckar.lizergy.model.invoice

import kotlinx.serialization.Serializable
import kotlin.jvm.JvmInline

@Serializable
@JvmInline
value class InvoiceNumber(val value: String)
